import React from 'react';
interface WhoIsForProps {
  onAddToCart: () => void;
}
export function WhoIsFor({
  onAddToCart
}: WhoIsForProps) {
  return <section className="py-20 md:py-28 px-4 bg-dark-secondary" data-id="element-749">
      <div className="max-w-content mx-auto" data-id="element-750">
        <div className="text-center mb-16" data-id="element-751">
          <h2 className="font-serif text-3xl md:text-4xl text-cream leading-tight mb-6 max-w-2xl mx-auto" data-id="element-752">
            ¿Te cuenta controlar los antojos y los bajones después de comer?
          </h2>
          <p className="font-sans text-gray-warm text-lg max-w-2xl mx-auto" data-id="element-753">
            Esta guía te da un plan simple para estabilizar tu energía y comer
            con más control y aplicar desde hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-754">
          {/* NOT FOR */}
          <div className="bg-dark-card rounded-xl p-8 border border-border-subtle" data-id="element-755">
            <h3 className="font-serif text-2xl text-cream mb-6" data-id="element-756">
              NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-757">
              <li className="flex items-start gap-3" data-id="element-758">
                <span className="text-red shrink-0 mt-1" data-id="element-759">✗</span>
                <span className="font-sans text-gray-warm text-[16px]" data-id="element-760">
                  Buscas una dieta mágica con resultados de la noche a la mañana
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-761">
                <span className="text-red shrink-0 mt-1" data-id="element-762">✗</span>
                <span className="font-sans text-gray-warm text-[16px]" data-id="element-763">
                  Esperas un diagnóstico o tratamiento médico (esto no lo
                  reemplaza)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-764">
                <span className="text-red shrink-0 mt-1" data-id="element-765">✗</span>
                <span className="font-sans text-gray-warm text-[16px]" data-id="element-766">
                  No estás dispuesto a leer etiquetas ni a cambiar lo que comes
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-767">
                <span className="text-red shrink-0 mt-1" data-id="element-768">✗</span>
                <span className="font-sans text-gray-warm text-[16px]" data-id="element-769">
                  Prefieres que alguien te diga qué comer sin entender por qué
                </span>
              </li>
            </ul>
          </div>

          {/* IS FOR */}
          <div className="bg-dark-card rounded-xl p-8 border border-gold/30 relative overflow-hidden" data-id="element-770">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 blur-2xl rounded-full" data-id="element-771"></div>
            <h3 className="font-serif text-2xl text-cream mb-6 relative z-10" data-id="element-772">
              SÍ es para ti si:
            </h3>
            <ul className="space-y-4 relative z-10" data-id="element-773">
              <li className="flex items-start gap-3" data-id="element-774">
                <span className="text-gold shrink-0 mt-1" data-id="element-775">✓</span>
                <span className="font-sans text-cream/90 text-[16px]" data-id="element-776">
                  Quieres entender qué hace el azúcar dentro de tu cuerpo más
                  allá de las dietas
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-777">
                <span className="text-gold shrink-0 mt-1" data-id="element-778">✓</span>
                <span className="font-sans text-cream/90 text-[16px]" data-id="element-779">
                  Te preocupa tu salud cardiovascular, tu energía o tu
                  envejecimiento
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-780">
                <span className="text-gold shrink-0 mt-1" data-id="element-781">✓</span>
                <span className="font-sans text-cream/90 text-[16px]" data-id="element-782">
                  Sientes que las consultas de 15 minutos no te dan respuestas
                  suficientes
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-783">
                <span className="text-gold shrink-0 mt-1" data-id="element-784">✓</span>
                <span className="font-sans text-cream/90 text-[16px]" data-id="element-785">
                  Quieres información científica real explicada en un lenguaje
                  que puedas entender
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-786">
                <span className="text-gold shrink-0 mt-1" data-id="element-787">✓</span>
                <span className="font-sans text-cream/90 text-[16px]" data-id="element-788">
                  Buscas herramientas prácticas, no teoría abstracta
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-789">
                <span className="text-gold shrink-0 mt-1" data-id="element-790">✓</span>
                <span className="font-sans text-cream/90 text-[16px]" data-id="element-791">
                  Este libro para tomar decisiones más informadas sobre tu
                  alimentación
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mb-10" data-id="element-792">
          <p className="font-sans italic text-gray-warm text-[13px]" data-id="element-793">
            Educativo y práctico. No es diagnóstico ni reemplaza atención
            médica.
          </p>
        </div>

        <div className="text-center" data-id="element-794">
          <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" onClick={onAddToCart} className="inline-block border border-gold text-gold hover:bg-gold hover:text-dark-primary font-sans font-bold text-[15px] py-3 px-8 rounded transition-colors mb-3" data-id="element-795">
            SÍ, quiero el ebook + bonos
          </a>
          <p className="font-sans text-[12px] text-gray-warm" data-id="element-796">
            Acceso inmediato · Descarga en 1 minuto · PDFs para siempre
          </p>
        </div>
      </div>
    </section>;
}